<template>
  <div id="app">
    <Page01 />
    <Page02 />
    <Page03 />
    <Page04 />
    <Page05 />
    <Page06 />
    <Page07 />
    <Page08 />
    <Page09 />
  </div>
</template>

<script>
import Page01 from './components/Page01.vue'
import Page02 from './components/Page02.vue'
import Page03 from './components/Page03.vue'
import Page04 from './components/Page04.vue'
import Page05 from './components/Page05.vue'
import Page06 from './components/Page06.vue'
import Page07 from './components/Page07.vue'
import Page08 from './components/Page08.vue'
import Page09 from './components/Page09.vue'

export default {
  name: 'app',
  components: {
    Page01,
    Page02,
    Page03,
    Page04,
    Page05,
    Page06,
    Page07,
    Page08,
    Page09
  }
}


</script>

<style>

@import url(http://fonts.googleapis.com/earlyaccess/notosanskr.css);

html {font-size:2.604vw;/*59px:1920px*/margin:0;padding:0;height:100%;font-family: 'Noto Sans KR', sans-serif;}
body{margin:0;padding:0;}
.clear{clear:both;}

#app {
  width:100%;
  height:100%;
}

.page {
  margin: 0 auto;
  width: 100%;
  height: max-content;
}

.content {
  margin:0 auto;
  width: 100%;
  height:max-content;
  background-position:center bottom;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color:#fff;
  position:relative;
}

a{text-decoration: none; color: #000; text-decoration-color: #000;}

.content>*{
  margin:0 auto;
}
.content>.content_area .item{float:left;font-size:1rem;line-height:1rem;}
.content>.content_area .item_left{margin-left:5.56rem;}

@media (max-width:720px) {

  html {font-size:4vw;}

  .content {
    background-size: auto 100%;
  }

  .content>.content_area .item{float:none;text-align:center;}
  .content>.content_area .item_left{margin:0;}
}

</style>
